import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";

interface Props {
  onAdd: () => void;
}

const SaveVersion: React.FC<Props> = ({ onAdd }) => {
  const { setModal } = useUtilityContext();

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label>This will create a new version of the prompt.</label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button
            onClick={onAdd}
            data-testid="modal-save-button"className="rounded-md bg-primary-700 px-4 py-2 text-white"
          >
            Save
          </button>
          <button
            onClick={() => setModal("saveVersion", false)}
            data-testid="save-modal-cancel-button" className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default SaveVersion;
